import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '@app/core/services/generic.service';

import { TipoDependencia } from '../models/tipo-dependencia.model';

@Injectable({
  providedIn: 'root'
})
export class TipoDependenciaService extends GenericService<TipoDependencia> {

  constructor(http: HttpClient) {
    super('censo/tipoDependencia', http);
  }

}
